import IconAlert from 'components/common/IconAlert';
import PlayerWidget from 'pages/components/PlayerWidget';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Col, Image, Row } from 'react-bootstrap';
import { createAvatar } from '@dicebear/core';
import { identicon } from '@dicebear/collection';

const Step4 = ({
  teamName,
  teamDescription,
  studentsData,
  students,
  teachersData,
  teacher,
  setShouldContinue
}) => {
  const teamLogo = createAvatar(identicon, {
    seed: teamName,
    size: 100
  }).toDataUriSync();

  useEffect(() => {
    setShouldContinue(true);
  }, []);

  return (
    <>
      <div className="mb-4 text-center">
        <Image src={teamLogo} className="mb-3" />
        <h3 className="fs-5 mb-2 font-weight-bold">{teamName}</h3>
        {teamDescription && (
          <h5 className="fw-light text-center mb-0">{teamDescription}</h5>
        )}
      </div>
      <div className="mb-4">
        <h5 className="mb-0 text-center text-700">Professore capoclasse</h5>
        <Row className="text-center justify-content-center">
          <Col className="mb-1">
            <PlayerWidget
              name={teachersData[teacher?.selected.value].name}
              price={teachersData[teacher?.selected.value].price}
              type="price"
            />
          </Col>
        </Row>
      </div>
      <div className="mb-4">
        <h5 className="mb-0 text-center text-700">Studenti</h5>
        <Row className="text-center">
          {students?.selected.map(function (student, index) {
            return (
              <Col sm={6} lg={3} className="mb-1" key={index}>
                <PlayerWidget
                  name={studentsData[student?.value].name}
                  price={studentsData[student?.value].price}
                  type="price"
                />
              </Col>
            );
          })}
        </Row>
      </div>
      <IconAlert variant="warning">
        <p className="mb-0">
          Attenzione - Ti ricordiamo che, una volta creata, la squadra{' '}
          <strong>non</strong> sarà più <strong>modificabile</strong>.
        </p>
      </IconAlert>
    </>
  );
};

Step4.propTypes = {
  teamName: PropTypes.string.isRequired,
  teamDescription: PropTypes.string,
  studentsData: PropTypes.object.isRequired,
  students: PropTypes.shape({
    selected: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string.isRequired
      })
    )
  }),
  teachersData: PropTypes.object.isRequired,
  teacher: PropTypes.shape({
    selected: PropTypes.shape({
      value: PropTypes.string.isRequired
    })
  }),
  setShouldContinue: PropTypes.func.isRequired
};

export default Step4;
